export const HDFC_BANK_OFFER_BINS = [
  '360765', '360825', '360826', '360886', '361010', '361011', '361135', '361168',
  '361573', '361575', '368357', '417410', '437546', '552385', '552389', '436152',
  '536311', '360827', '360887', '361215', '361216', '436152', '536311', '653005',
  '652941', '652943', '653060', '653061', '361577', '652940', '405028', '418136',
  '434155', '434677', '434678', '457262', '457704', '461786', '461787', '463202',
  '463917', '485498', '485499', '489377', '517635', '517652', '518159', '524111',
  '524216', '524368', '528945', '531909', '537206', '545226', '545964', '552088',
  '552260', '552274', '552344', '552365', '552394', '553583', '556042', '558818',
  '558983', '652850', '652895', '652915', '652916', '652937', '652972', '653029',
  '653049', '45146901', '463918', '451104', '442145', '442149', '451104', '463919',
  '467742', '488994', '524487', '532961', '532973', '540536', '553162', '555153',
  '556620', '559197', '653048', '471865', '434168', '817998', '442142', '442144',
  '652989', '653080', '652988',
] as const;

export type BankOfferEligibility = 'idle' | 'pending' | 'eligible' | 'ineligible';

export const getHdfcBankOfferEligibility = (cardNumber: string): BankOfferEligibility => {
  const digits = cardNumber.replace(/\D/g, '');
  if (digits.length < 6) return 'idle';

  if (HDFC_BANK_OFFER_BINS.some((bin) => digits.startsWith(bin))) return 'eligible';

  const isIncompleteEightDigitBin = HDFC_BANK_OFFER_BINS.some(
    (bin) => bin.length > digits.length && bin.startsWith(digits)
  );
  return isIncompleteEightDigitBin ? 'pending' : 'ineligible';
};

export const isHdfcBankOfferCard = (cardNumber: string): boolean =>
  getHdfcBankOfferEligibility(cardNumber) === 'eligible';
